export const DASHBOARD = "dashboard";
export const READONLY = "readonly";
export const READWRITE = "readwrite";
export const ADMIN = "admin";

export const USER_ROLES = [
  { value: READONLY, label: "Read Only" },
  { value: READWRITE, label: "Read Write" },
  { value: ADMIN, label: "Admin" },
];

export const getUserRole = (type) => {
  const item = USER_ROLES.find((it) => it.value === type);
  if (item) {
    return item.label;
  }

  return "";
};

export const YES_NO_OPTIONS = [
  { value: true, label: "Yes" },
  { value: false, label: "No" },
];

// OEM is stored as a lowercase slug string on the registration (e.g. "foxess").
// No /option source yet — confirm the full list / slugs with backend and move
// to /option when available.
export const BATTERY_OEMS = [
  { value: "foxess", label: "FoxESS" },
  { value: "sigenergy", label: "Sigenergy" },
];

